import React from 'react'

import Button from './button'

export default function Newsletter() {
  return (
    <div className="w-full lg:w-5/12 lg:ps-4">
      <p>
        Inscreva-se na nossa lista de e-mails e receba novidades sempre em
        primeira mão!
      </p>
      <form className="flex flex-row mt-3 me-3 gap-x-1 md:gap-x-4">
        <input
          type="email"
          className="grow h-8 px-2 md:px-3 text-sm rounded-[10px] text-black/90"
          placeholder="Digite seu e-mail"
        />
        <button type="submit">
          <Button
            href="#"
            size="tiny"
            color="red"
            label="Inscreva-se"
            className="relative py-2.5 -top-[2px]"
          />
        </button>
      </form>
    </div>
  )
}
